<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in filteredItems"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref, computed } from '@vue/composition-api'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'
import store from '@/store'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    provide('openGroups', ref([]))

    // Kullanıcı rolleri
    const isAdmin = store.getters['user/isAdmin'];
    const isSaleTeam = store.getters['user/isSaleTeam'];
    const isDeveloper = store.getters['user/isDeveloper'];
    const isInfluencer = store.getters['user/isFenomen']; // ✅ yeni eklendi

    // Filtrelenmiş öğeler
    const filteredItems = computed(() => {

  // 1. YARDIMCI FONKSİYON: Yetki Kontrolü
  // Bu fonksiyon hem Parent hem de Child öğeler için kullanılır.
  const hasPermission = (roleRaw) => {
    // Eğer öğede rol tanımlı değilse herkes görebilir
    if (!roleRaw) return true;

    const roles = roleRaw.split(',').map(r => r.trim());

    // Developer: 'influencer' hariç her şeyi görür
    if (isDeveloper) {
      return !roles.includes('influencer');
    }

    // Admin: Sadece 'admin' rolünü görür
    if (isAdmin) return roles.includes('admin');

    // Sale Team: Sadece 'sale_team' rolünü görür
    if (isSaleTeam) return roles.includes('sale_team');

    // Influencer: Sadece 'influencer' rolünü görür
    if (isInfluencer) return roles.includes('influencer');

    // Hiçbir şart uymuyorsa (yetkisiz kullanıcı) gizle
    return false;
  };

  // 2. FİLTRELEME MANTIĞI
  return props.items
    .map(item => {
      // ÖNCE PARENT KONTROLÜ:
      // Parent'ın kendisi yasaklıysa (örneğin Admin'e Sale menüsü),
      // altındakilere bakmaya gerek yok, direkt null dön.
      if (!hasPermission(item.role)) {
        return null;
      }

      // SONRA CHILDREN KONTROLÜ:
      // Parent görünürse, çocukları tek tek aynı süzgeçten geçir.
      if (item.children) {
        const filteredChildren = item.children.filter(child => hasPermission(child.role));
        
        // Parent'ı ve filtrelenmiş çocukları döndür
        return { ...item, children: filteredChildren };
      }

      // Çocuğu olmayan düz bir öğe ise ve izni geçtiyse döndür
      return item;
    })
    .filter(Boolean); // null dönen (yetkisiz) parentları diziden temizle
});


    return {
      resolveNavItemComponent,
      filteredItems,
    }
  },
}
</script>

